import React from 'react';
import { ClipboardList, ShieldCheck, Activity } from 'lucide-react';
import SEO from '../components/SEO';
import SpecialtyPageTemplate from '../components/SpecialtyPageTemplate';

const ConsultationPage = () => {
  const config = {
    badge: "Clinical Consultation",
    headline: "Expert Clinical",
    headlineItalic: "Consultation.",
    subtext: "Thorough, compassionate wellness exams and clinical consultations that form the foundation of your pet's long-term health journey.",
    image: "/images/services/diagnostics_lab.png",
    imageAlt: "Veterinary Consultation at Dr. Suresh Pet Care — Expert Wellness Exams",
    stats: [
      { value: 15000, suffix: '+', label: 'Consultations Done' },
      { value: 99, suffix: '%', label: 'Client Satisfaction' },
      { value: 10, suffix: '+', label: 'Years Expertise' },
      { value: 24, suffix: '/7', label: 'Emergency Access' },
    ],
    services: [
      {
        title: "Wellness Examination",
        icon: <ClipboardList size={28} />,
        desc: "Comprehensive head-to-tail physical examination assessing every system for early disease detection.",
        specs: ["Full Physical Exam", "Weight Assessment", "Vital Signs", "Lymph Node Check"],
        color: "from-green-500/10 to-primary/10"
      },
      {
        title: "Senior Pet Health",
        icon: <Activity size={28} />,
        desc: "Specialized protocols for aging pets, including organ function monitoring and mobility assessments.",
        specs: ["Geriatric Bloodwork", "Arthritis Screening", "Cognitive Assessment", "Nutritional Review"],
        color: "from-primary/10 to-amber-500/10"
      },
      {
        title: "Second Opinion",
        icon: <ShieldCheck size={28} />,
        desc: "Thorough and unbiased clinical review of complex diagnoses to ensure the best treatment path.",
        specs: ["Record Review", "Independent Diagnosis", "Treatment Options", "Specialist Referral"],
        color: "from-blue-500/10 to-primary/10"
      }
    ],
    sectionTitle: "Our Consultation",
    sectionItalic: "Services.",
    warningTitle: "When to Seek",
    warningItalic: "Consultation.",
    warningText: "Early consultation is always better. These signs indicate your pet needs professional evaluation as soon as possible.",
    warnings: [
      { name: "Sudden Behavior Change", desc: "Aggression, hiding, or unusual restlessness can signal pain or illness.", icon: "🐾" },
      { name: "Loss of Appetite", desc: "Refusing food for more than 24 hours warrants immediate evaluation.", icon: "🍽️" },
      { name: "Limping or Pain", desc: "Any sign of discomfort or mobility issues needs professional assessment.", icon: "🦴" },
      { name: "Unusual Discharge", desc: "Eye, ear, or nasal discharge of any kind merits prompt clinical review.", icon: "👁️" },
    ],
    ctaBadge: "Clinical Care",
    ctaTitle: "The Consultation",
    ctaItalic: "Expertise.",
    ctaText: "Dr. T Suresh Babu and his clinical team provide thorough, evidence-based consultations for all pet health concerns in Hyderabad.",
    ctaBtn: "Book a Consultation",
    seoText: "Expert veterinary consultation and wellness exams in Hyderabad. Comprehensive pet health check-up and clinical evaluation at Dr. Suresh Pet Care.",
    glowColor: "green-500"
  };

  return (
    <>
      <SEO 
        title="Veterinary Consultation & Wellness Exams"
        description="Expert veterinary consultations and comprehensive wellness examinations for your pets at Dr. Suresh Pet Care, Hyderabad."
        canonical="/consultation"
      />
      <SpecialtyPageTemplate config={config} />
    </>
  );
};


export default ConsultationPage;
